import "./SmartHomeTipsAndTricks.module.css";
import Header from "@/reusable_sections/Header";
import SmartHomeTipsListing from "./sections/SmartHomeTipsListing";
import SubmitANewTip from "./sections/SubmitANewTip";
import AboutSimpleLiving from "./sections/AboutSimpleLiving";
import Footer from "@/reusable_sections/Footer";
export default function SmartHomeTipsAndTricksPage() {
  return <div>
      <Header />
      <SmartHomeTipsListing />
      <SubmitANewTip />
      <AboutSimpleLiving />
      <Footer />
    </div>;
}